import React from "react";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StuDetail from "../Components/Student/StudentDetail";
import TopBar from "../Components/TopBar";
import SideBar from "../Components/SideBar";

function StudentData() {
	const navigate = useNavigate();
	useEffect(() => {
		const checkLogin = () => {
			if (localStorage.getItem("type") !== "admin") {
				navigate("/login");
			} else if (!localStorage.getItem("auth_token")) {
				navigate("/login");
			}
		};
		checkLogin();
	});
	return (
		<>
			<SideBar />
			<TopBar />
			<div className="container">
				<StuDetail />
			</div>
		</>
	);
}

export default StudentData;
